import Typography from "@mui/material/Typography";
import { TicketStatus as Status } from "entities/customerTickets/types";
import React, { FC } from "react";
import { COLOR_GREY_12, COLOR_GREY_11 } from "shared/theme/colors";
import {
  StyledCategoryContainer,
  StyledTicketChatHeaderContainer,
} from "./styled";
import TicketStatus from "../../../TicketStatus";

type Props = {
  ticketTitle: string;
  ticketCategory?: string;
  ticketSubcategory?: string;
  status: Status | null;
};

const Header: FC<Props> = ({
  ticketCategory,
  ticketSubcategory,
  ticketTitle,
  status,
}) => {
  return (
    <StyledTicketChatHeaderContainer>
      <Typography variant="bodyXLMedium" color={COLOR_GREY_12}>
        {ticketTitle}
      </Typography>
      <StyledCategoryContainer>
        <Typography variant="bodySRegular" color={COLOR_GREY_11}>
          {ticketCategory} {ticketSubcategory && ">"} {ticketSubcategory}
        </Typography>
        {status && <TicketStatus status={status} />}
      </StyledCategoryContainer>
    </StyledTicketChatHeaderContainer>
  );
};

export default Header;
